import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nopass",
  "use": "icon-nopass-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nopass\"><path d=\"M799.68 287.68a44.8 44.8 0 0 0-63.36-63.36L512 448.64 287.68 224.32a44.8 44.8 0 1 0-63.36 63.36L448.64 512l-224.32 224.32a44.8 44.8 0 0 0 63.36 63.36L512 575.36l224.32 224.32a44.8 44.8 0 0 0 63.36-63.36L575.36 512l224.32-224.32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol